import { useTranslation } from 'react-i18next';

/**
 * Full-screen "Initialising" state shared by every auth bootstrap gate
 * (`AuthConfigLoader`, `AuthRouterBoundary`, and `/login` while a completed
 * sign-in navigates away). These sit above `RouterProvider`, so they can't use
 * the router's own `defaultPendingComponent` — keeping one component means the
 * hand-offs between them are invisible instead of three near-identical spinners.
 */
export function BootScreen() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center" role="status" aria-live="polite">
        <div
          className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-primary/20 border-t-primary"
          aria-hidden="true"
        />
        <p className="font-medium text-muted-foreground">
          {t('common.initialising')}
        </p>
      </div>
    </div>
  );
}
